export default function SiteHeader() {
  return (
    <header className="w-full p-4 shadow-sm bg-white">
      <div className="max-w-5xl mx-auto flex justify-between items-center">
        <h1 className="text-xl font-semibold">Brown Trout Systems</h1>
        <nav className="space-x-6 text-sm">
          <a href="/services">Services</a>
          <a href="/remote-support">Remote Support</a>
          <a href="/contact">Contact</a>
        </nav>
      </div>
    </header>
  );
}
